module.exports = __webpack_public_path__ + "static/img/5.fe6d10d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/zh/5.png
// module id = p5os
// module chunks = 0